import { UserResource } from '../user/user.resource';
import { projectConfigs as projectConfigsStore } from '../../store';
import { ProjectSettingResource } from './project-setting.resource';
class ProjectConfigService {
    constructor() {
        this.userResource = new UserResource();
        this.projectSettingResource = new ProjectSettingResource();
    }
    async resolve() {
        const projectConfigs = await this.userResource.getProjects();
        projectConfigsStore.setProjects(projectConfigs);
    }
    get(key) {
        const projectConfigs = projectConfigsStore.getProjects();
        return projectConfigs.find((projectConfig) => projectConfig.key === key);
    }
    getCategoryConfig(project, category, featured = false) {
        const projectConfig = this.get(project);
        const categories = featured
            ? projectConfig.featuredCategories
            : projectConfig.categories;
        return categories.find((categoryConfig) => categoryConfig.key === category);
    }
    fetchProjectSettings(project) {
        return this.projectSettingResource.getAll(project);
    }
    async updateProjectSetting(setting) {
        const { project, key, value } = setting;
        const updatedSetting = await this.projectSettingResource.update({
            project,
            key,
            value: JSON.stringify(value),
        });
        return Object.assign(Object.assign({}, updatedSetting), { value: JSON.parse(updatedSetting.value) });
    }
}
export default new ProjectConfigService();
